


























import { Vue, Component, Prop } from 'vue-property-decorator';

import ChevronRightSolid from '~/components/icons/ChevronRightSolid.vue';

@Component({
  components: { ChevronRightSolid },
})
export default class CustomAccordion extends Vue {
  @Prop(String) title: '';

  isActive: boolean = false;
}
